import { callPerlita, formatConversationAsText } from "../ApiCalls/perlita";

/**
 * Analyzes a conversation using Perlita
 * @param {Object} conversation - Conversation object
 * @param {Array} messages - Array of message objects
 * @param {string} prompt - The prompt to use for analysis
 * @param {Object} options - Additional options for Perlita call
 * @returns {Promise<Object>} Analysis result
 */
export const analyzeConversation = async (conversation, messages, prompt, options = {}) => {
  try {
    // Format conversation as text
    const conversationText = formatConversationAsText(messages);
    
    // Add conversation context to prompt
    const fullPrompt = `${prompt}\n\nConversación a analizar:\n\n${conversationText}`;

    // Call Perlita
    const response = await callPerlita(fullPrompt, [], {
      model: options.model || ["us.anthropic.claude-haiku-4-5-20251001-v1:0"],
      temperature: options.temperature || 0.7,
      system_instructions: options.system_instructions || "Eres un analista experto en conversaciones. Responde siempre en formato JSON válido.",
      timeout: options.timeout || 60000,
      token: options.token,
    });

    // Try to parse JSON response
    let analysisResult;
    try {
      // Handle different response formats
      const responseText = typeof response === "string" 
        ? response 
        : response.response || response.text || JSON.stringify(response);
      
      // Clean up response (remove markdown code blocks if present)
      const cleanedResponse = responseText
        .replace(/```json\n?/g, "")
        .replace(/```\n?/g, "")
        .trim();
      
      analysisResult = JSON.parse(cleanedResponse);
    } catch (parseError) {
      console.warn("Could not parse JSON response, using raw response:", parseError);
      analysisResult = {
        error: "Error de análisis",
        message: `No se pudo parsear la respuesta: ${JSON.stringify(response)}`,
      };
    }

    return {
      success: true,
      data: analysisResult,
      rawResponse: response,
    };
  } catch (error) {
    console.error("Error analyzing conversation:", error);
    return {
      success: false,
      error: error.message || "Error desconocido",
      data: {
        error: "Error de análisis",
        message: `Error al procesar: ${error.message}`,
      },
    };
  }
};

